import { Control } from "./control";
import { gsap } from "gsap";

export class ShareButtons extends Control {
    private shareButton: HTMLButtonElement;
    private shareLinkContainer: HTMLUListElement;
    private shareLinks: NodeListOf<HTMLAnchorElement>;
    private shareAnimate!: GSAPTimeline;

    public static selector: string = ".share";

    private readonly title?: string;
    private description?: string;

    constructor(containerElement: Element) {
        super(containerElement);

        // elements
        this.shareButton = this.container.querySelector("#buttonShare") as HTMLButtonElement;
        this.shareLinkContainer = this.container.querySelector("#shareOptions") as HTMLUListElement;
        this.shareLinks = this.shareLinkContainer.querySelectorAll("li a");

        if (!this.shareLinkContainer || !this.shareButton) {
            console.warn("Share elements not found");
            return; 
        }

        // animation timeline
        this.shareAnimate = gsap
            .timeline({
                paused: true,
                onReverseComplete: () => {
                    this.shareLinkContainer.hidden = true;
                },
            })
            .fromTo(
                this.shareLinkContainer,
                { height: 0, opacity: 0 },
                {
                    height: "auto",
                    opacity: 1,
                    ease: "back.out(1)",
                    duration: 0.5,
                }
            );
    

        // events
        if (this.shareButton) {
            this.shareButton.addEventListener("click", () => this.onShareButtonClick());
        }

        this.shareLinks.forEach(link => link.addEventListener("click", evt => this.onShareLinkClick(evt)));
        
        // properties
        this.title = (document.querySelector("meta[property='og:title']") as HTMLMetaElement)?.content || document.title;
        this.description = (document.querySelector("meta[property='description']") as HTMLMetaElement)?.content;
    }

    private onShareButtonClick(): void {
        if (this.shareButton.getAttribute("aria-expanded") === "false") {
            this.shareButton.setAttribute("aria-expanded", "true");
            this.shareLinkContainer.hidden = false;
            this.shareAnimate.play();
        } else {
            this.shareButton.setAttribute("aria-expanded", "false");
            this.shareAnimate.reverse();
        }
    }

    private onShareLinkClick(event: MouseEvent) {
        const button = event.currentTarget as HTMLAnchorElement;
        const listItem = button.closest("li");
    
        if (!listItem) {
            console.warn("Share link not in expected DOM structure");
            return;
        }
        
        const network = listItem.getAttribute("data-network");
        const title = encodeURIComponent(this.title ?? "");
        const url = encodeURIComponent(this.GetShareUrl());
        
        event.preventDefault();
        
        switch (network) {
            case "facebook":
                this.openShareDialog(`https://www.facebook.com/sharer/sharer.php?u=${url}`, network);
                break;
                
            case "x":
                this.openShareDialog(`https://x.com/intent/tweet?url=${url}&text=${title}`, network);
                break;
                
            case "email":
                window.location.href = `mailto:?subject=${title}&body=${url}`;
                break;
        }
    }
    
    private openShareDialog(url: string, network: string) {
        if (!url)
            return;
        
        window.open(url, network + "-share-dialog", "width=626,height=436");
    }
    
    private GetShareUrl(): string {
        return (document.querySelector("meta[property='og:url']") as HTMLMetaElement)?.content || window.location.href;
    }
}
